<template>
  <div class="empty-state__page">
    <div>
      <VcEmptyState size="sm"
                    @click="removeSelected"
                    :title="title"
                    :subtitle="subTitle"
                    :button="button"
                    :outlinedButton="true"
                    :image="selectedElements ? InboxSelectedImg : InboxEmptyStateImg"/>
    </div>
  </div>
</template>

<script>
import {postMessageService} from "@/modules/common/services";

export default {
  name: 'InboxEmptyState',
  data() {
    return {
      selectedElements: 0,
    }
  },
  created() {
    window.addEventListener('message', this.handleFrontageMessage)
  },
  computed: {
    InboxEmptyStateImg() { return require('@/assets/images/inboxConversation.svg')},
    InboxSelectedImg() { return require('@/assets/images/inboxSelect.svg')},
    title() {
      return this.$t(`conversation.empty_state.${this.selectedElements ? 'selected' : 'empty'}`, {amount:this.selectedElements})
    },
    subTitle() {
      return !this.selectedElements && this.$t(`conversation.empty_state.empty_subtitle`) || ''
    },
    button() {
      return this.selectedElements && this.$t(`conversation.empty_state.clear`) || ''
    }
  },
  methods: {
    updateSelected(amount) {
      this.selectedElements = amount;
    },
    removeSelected() {
      postMessageService.post('removeSelected')
    },
    handleFrontageMessage({data}) {
      if(data.source !== 'frontage-message') return
      switch (data.message.event) {
        case 'selectedElements':
          this.updateSelected(data.message.data.amount)
          break;
      }
    }
  },
  destroyed() {
    window.removeEventListener('message', this.handleFrontageMessage)
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
  &__page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
}
</style>
